import { render, staticRenderFns } from "./message-item.vue?vue&type=template&id=8135740a&scoped=true"
import script from "./message-item.vue?vue&type=script&lang=ts"
export * from "./message-item.vue?vue&type=script&lang=ts"
import style0 from "./message-item.vue?vue&type=style&index=0&id=8135740a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8135740a",
  null
  
)

export default component.exports